<template>
  <v-card
    class="mx-auto parent-list-overflow rounded-card card-shadow"
    height="450"
    max-height="450"
  >
    <v-card-title class="headline text--primary font-weight-bold">
      Aprovações pendentes
    </v-card-title>
    <v-card-text class="text--primary list-overflow">
      <div v-if="loading">
        <px-circular-loading/>
      </div>
      <div>
        <v-list class="mt-3" v-if="!loading && aprovacoes.length">
          <template v-for="aprovacao in aprovacoes">
            <v-list-item link :to="`aprovacao-compra/${aprovacao.id}`" :key="aprovacao.id">
              <v-list-item-content>
                <v-row dense no-gutters>
                  <v-col cols="12" sm="5">
                    {{ nomeFornecedor(aprovacao) | truncate(30) }}
                  </v-col>
                  <v-col cols="12" sm="5">
                    {{ aprovacao.comprador.pessoa.nome | truncate(25) }}
                  </v-col>
                  <v-col cols="12" sm="2" class="text-center">
                    {{ aprovacao.valorMoedaConvertido.total | currency }}
                    <template v-if="isMoedaEstrangeiraFn(aprovacao.moeda)">
                      <px-moeda-chip :moeda="aprovacao.moeda"/>
                      <div class="caption">
                        {{
                          aprovacao.total
                            | currency(simboloMoedaFn(aprovacao.moeda), 2,
                            configuracaoFormatacaoMoedaFn(aprovacao.moeda))
                        }}
                      </div>
                    </template>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider :key="`div-${aprovacao.id}`"/>
          </template>
        </v-list>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import moedaMixin from '@/mixins/moeda-mixin';
import AprovacaoCompraService from '@/modules/aprovacao-compra/aprovacao-compra-service';
import { SituacaoAprovacao } from 'px-business-components';

export default {
  mixins: [moedaMixin],
  computed: {
    nomeFornecedor() {
      return aprovacao => aprovacao.nomeInternoFornecedor || aprovacao.fornecedor.pessoa.nome;
    },
  },
  data() {
    return {
      loading: false,
      aprovacoes: [],
    };
  },
  methods: {
    getAprovacoes() {
      this.loading = true;
      AprovacaoCompraService.getList({
        query: 'situacao in ("PENDENTE") order by createdIn desc',
        limit: 20,
        offset: 0,
        situacao: SituacaoAprovacao.keys.PENDENTE.key,
      })
        .then(({ data }) => {
          this.aprovacoes = data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getAprovacoes();
  },
};
</script>

<style scoped>
.parent-list-overflow {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.list-overflow {
  width: 100%;
  height: 395px;
  max-height: 395px;
  padding-right: 17px;
  overflow-y: scroll;
  box-sizing: content-box;
}
</style>
